var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _g, _path2, _rect7, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutlookPrdct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 88,
    viewBox: "0 0 100 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    width: 62.5,
    height: 87.5,
    rx: 2,
    fill: "#1066B5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    width: 62.5,
    height: 87.5,
    rx: 2,
    fill: "url(#paint0_linear_2919_135)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 9.375,
    width: 31.25,
    height: 31.25,
    fill: "#32A9E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 40.625,
    width: 31.25,
    height: 31.25,
    fill: "#167EB4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 40.625,
    width: 31.25,
    height: 31.25,
    fill: "#32A9E7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 9.375,
    width: 31.25,
    height: 31.25,
    fill: "#58D9FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2919_135",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 37,
    width: 75,
    height: 51
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 37.5H98C99.1046 37.5 100 38.3954 100 39.5V85.5C100 86.6046 99.1046 87.5 98 87.5H27C25.8954 87.5 25 86.6046 25 85.5V37.5Z",
    fill: "url(#paint1_linear_2919_135)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2919_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 37.5V50H93.75V37.5H100Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 87.5V43.75L21.875 87.5H100Z",
    fill: "url(#paint2_linear_2919_135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 87.5V43.75L103.125 87.5H25Z",
    fill: "url(#paint3_linear_2919_135)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24.875C25 23.2181 26.3431 21.875 28 21.875H59.5C61.1569 21.875 62.5 23.2181 62.5 24.875V75.125C62.5 76.7819 61.1569 78.125 59.5 78.125H25V24.875Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 15.625,
    width: 56.25,
    height: 56.25,
    rx: 2,
    fill: "url(#paint4_linear_2919_135)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 43.9664V43.447C43.75 34.4443 37.2725 28.125 28.1744 28.125C19.0269 28.125 12.5 34.4875 12.5 43.5336V44.053C12.5 53.0557 18.9775 59.375 28.125 59.375C37.2231 59.375 43.75 53.0125 43.75 43.9664ZM36.3825 44.053C36.3825 50.026 33.0202 53.6184 28.1744 53.6184C23.3287 53.6184 19.9169 49.9394 19.9169 43.9664V43.447C19.9169 37.474 23.2793 33.8816 28.125 33.8816C32.9213 33.8816 36.3825 37.5606 36.3825 43.5336V44.053Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2919_135",
    x1: 31.25,
    y1: 43.75,
    x2: 93.75,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2919_135",
    x1: 25,
    y1: 77.4038,
    x2: 100,
    y2: 77.4038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2919_135",
    x1: 100,
    y1: 65.625,
    x2: 25,
    y2: 65.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2919_135",
    x1: 25,
    y1: 65.625,
    x2: 100,
    y2: 65.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2919_135",
    x1: 0,
    y1: 43.75,
    x2: 56.25,
    y2: 43.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookPrdct);
export default __webpack_public_path__ + "static/media/outlook-prdct.53f269e35e58035d822811a1b09cdfff.svg";
export { ForwardRef as ReactComponent };